import IconWrapper, {
  IconColors, IconSizes,
} from './icon-wrapper';

export {
  IconColors,
  IconSizes,
};

export default IconWrapper;
